<script setup>
import { addThousandsSeparator } from '~/utils/utils.js';
import Card from '~/components/Card.vue';
import LoadingSkeleton from '~/components/LoadingSkeleton.vue';

const props = defineProps({
    holdingPeriods: { type: Array, default: [] },
    loading: { type: Boolean, default: false }
});
</script>

<template>
    <Card>
        <!-- Section Header -->
        <div class="flex items-center mb-6">
            <CardLabel text="Kaspa Holding Periods" />
            <InfoTooltip text="Distribution of how long addresses have been holding their KAS" />
        </div>

        <!-- Stats Grid -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <template v-if="props.loading">
                <div v-for="i in 9" :key="i">
                    <LoadingSkeleton height="110px" width="100%" />
                </div>
            </template>
            <template v-else>
                <div v-for="(stat, index) in props.holdingPeriods" :key="index" class="slide-in-up">
                    <div class="relative rounded-xl p-4 bg-white dark:bg-gray-700/50 border border-gray-100 dark:border-transparent">
                        <div class="text-sm font-semibold text-gray-600 dark:text-gray-400 truncate mb-2">
                            {{ stat.period }}
                        </div>
                        <div class="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#70C7BA] to-[#4A8D83] dark:text-white mb-3">
                            {{ addThousandsSeparator(stat.percentage, 2) }}%
                        </div>
                        <div class="mt-2 w-full h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                            <div class="h-full bg-gradient-to-r from-[#70C7BA] to-[#4A8D83]" :style="{ width: `${stat.percentage}%` }"></div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </Card>
</template>